<template>
  <div id="sns-conteiner">
    <ol>
      <li v-for="item in items"
      v-on:click="onClick(item.path)"
      > {{ item.title }}
      <!-- <img :src="../assets/sns_logos/{{item.name}}.png" alt=""> -->
      <img :src="item.icon" alt="">
    </li>
    </ol>
  </div>
</template>

<script>

export default {
  name: 'RadiusButton',
  data () {
    return {
      title: 'this will head',
      items: [
        { name: 'twitter', icon: require('../assets/sns_logos/twitter.png'), path: 'https://twitter.com/churabou1' },
        { name: 'facebook', icon: require('../assets/sns_logos/facebook.png'), path:'https://www.facebook.com' },
        { name: 'instagram', icon: require('../assets/sns_logos/instagram.png'), path: 'https://www.instagram.com/' },
        { name: 'github', icon: require('../assets/sns_logos/github.png'), path: 'https://github.com/churabou' },
        { name: 'hatenablog', icon: require('../assets/sns_logos/hatenablog.png'), path: 'https://churabou.hatenablog.com/'},
      ]
    }
  },

  methods: {
    onClick: function(path) {
      window.location.href = path
    }
  }
}

</script>

<style scoped>

#sns-conteiner li {
  /* background-color: red; */
  display: inline-block;
  margin-left: 30px;
}

#sns-conteiner img {
  width: 100px;
  height: 100px;
  background-size: contain;
}

#sns-conteiner img:hover {
  opacity: 0.5;
}

</style>



// WEBPACK FOOTER //
// src/components/SnsField.vue